<ng-content select="exl-avatar, mulo-avatar"></ng-content>
<ng-content select="exl-person-brief-title"></ng-content>
<ng-content></ng-content>
<ng-content select="[slot='brief-tags']"></ng-content>
